export default __webpack_public_path__ + "c3fa1b43c10ea70b8264a4e73583653a.png";